import { cn } from "cy-fe/src/utils/cn";
import { ReactNode, useId } from "react";

export function Tab<T extends string>({
  className,
  children,
}: {
  selectedTab: T;
  className?: string;
  onChange?: (tab: T) => void;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "text-default grid grid-cols-2 gap-2 rounded bg-gray-100 px-3 py-1 text-sm font-normal sm:max-w-[32rem]",
        "mx-2 sm:mx-auto",
        className,
      )}
    >
      {children}
    </div>
  );
}
export function TabButton<T extends string>({
  children,
  selected,
  onchange,
  value,
}: {
  children: ReactNode;
  value: T;
  selected?: boolean;
  onchange?: (tab: T) => void;
}) {
  const id = useId();
  return (
    <button
      tabIndex={0}
      type="button"
      onClick={() => onchange?.(value)}
      className={cn(
        "relative block rounded py-[0.4rem]",
        "text-center ring-[length:var(--control-ring-width-base)] outline-none",
        "hover:cursor-pointer",
        // Selected state: white background with border and shadow
        selected && "text-default border-control-border border bg-white shadow",
        // Unselected state: transparent border (reserves space to prevent shift on hover)
        !selected && "text-default/75 border border-transparent",
        // Hover states: border and ring widths from CSS variables
        "hover:border-control-border-hover hover:border",
        "hover:ring-[length:var(--control-ring-width-hover)]",
        "hover:ring-control-ring-hover",
        // Focus states: border and ring widths from CSS variables
        "focus:border-control-border-focus focus:border",
        "focus:ring-[length:var(--control-ring-width-focus)]",
        "focus:ring-control-ring-focus",
      )}
    >
      <input
        id={id}
        type="radio"
        tabIndex={-1}
        className="sr-only select-none"
        name="tab"
        value={value}
        checked={selected}
        onChange={(e) => onchange?.(e.target.value as T)}
      />
      {children}
    </button>
  );
}
